import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { InstituteReport, ReportPeriod } from '@/types/instituteReport';

/** Every network call the reports feature makes (CLAUDE.md §6). */
export const reportsApi = {
  institute: (uuid: string, days: ReportPeriod) =>
    unwrap(
      apiClient.get<ApiSuccess<InstituteReport>>(`/platform/institutes/${uuid}/report`, {
        params: { days },
      }),
    ),
};
